import { RectangleBlockProps } from './type';

interface Props {
  blockProps: RectangleBlockProps;
  scaleFactor?: number;
  maxWidth: number;
}

export const RectangleBlock: React.FC<Props> = (props) => {
  const { blockProps, maxWidth, scaleFactor = 1 } = props;
  const {
    width = 10,
    fontSize,
    backgroundColor,
    borderColor,
    height = 10,
    borderWidth = 1,
  } = blockProps;

  return (
    <div
      style={{
        maxWidth: maxWidth * scaleFactor,
        fontSize: `${fontSize * scaleFactor}px`,
      }}
    >
      <div
        style={{
          width: `${width * scaleFactor}px`,
          height: `${height * scaleFactor}px`,
          borderStyle: 'solid',
          borderWidth: `${borderWidth}px`,
          borderColor: borderColor ?? '#000000',
          backgroundColor: backgroundColor || 'transparent',
          boxSizing: 'border-box',
        }}
      ></div>
    </div>
  );
};
